'use client';

import { NetworkWaveform } from '@/features/diagnostics';
import styles from './GlobalNetworkIndicator.module.css';

export const GlobalNetworkIndicator = () => (
  <div className={styles.wrap} aria-hidden={true}>
    <NetworkWaveform
      width={200}
      height={14}
      singleDirection={true}
      color="#fff"
    />
  </div>
);
